
function read(key,defaultValue="",temporary=false){
  if(typeof(Storage)!=="undefined"){
    if(temporary){
      return window.sessionStorage.getItem(key)??defaultValue
    }else{
      return window.localStorage.getItem(key)??defaultValue
    }
  }
  return defaultValue
}

function write(key,value,temporary=false){
  if(typeof(Storage)!=="undefined"){
    if(temporary){
      window.sessionStorage.setItem(key,value)
    }else{
      window.localStorage.setItem(key,value)
    }
    return true
  }
  return false
}

export {read,write}